import { useEffect, useState } from 'react';
import CookieBanner from './components/extra/CookieBanner';
import Credits from './components/extra/Credits';
import Header from './components/extra/Header';
import SeoContentBlock from './components/extra/SeoContentBlock';
import TestimonialsSection from './components/extra/TestimonialsSection';
import ContributionsManager from './features/dataset/ContributionsManager';
import PremiumFeaturesSlot from './features/premium/PremiumFeaturesSlot';
import TranscriptionWorkspace from './features/transcription/TranscriptionWorkspace';
import './styles/common.css';

const { getSeoLandingPageByPath } = require('./seo/landingPages');

function languageFromPath() {
  const match = window.location.pathname.match(/^\/([a-z]{2})\/?$/);
  return match ? match[1] : 'ca';
}

export default function App() {
  const [isPremium, setIsPremium] = useState(false);
  const [language, setLanguage] = useState(languageFromPath);
  const [mode, setMode] = useState(() => localStorage.getItem('transcriptionMode') || 'quality');
  const [showPremiumPopup, setShowPremiumPopup] = useState(false);
  const [userData, setUserData] = useState(null);
  const landingPage = getSeoLandingPageByPath(window.location.pathname);

  useEffect(() => localStorage.setItem('transcriptionMode', mode), [mode]);

  const changeLanguage = (nextLanguage) => {
    setLanguage(nextLanguage);
    window.history.pushState({}, '', nextLanguage === 'ca' ? '/' : `/${nextLanguage}`);
  };

  if (window.location.pathname === '/aportacions') {
    return <><ContributionsManager /><Credits /><CookieBanner /></>;
  }

  return (
    <div>
      <PremiumFeaturesSlot
        showPremiumPopup={showPremiumPopup}
        setShowPremiumPopup={setShowPremiumPopup}
        userData={userData}
        setUserData={setUserData}
        isPremium={isPremium}
        setIsPremium={setIsPremium}
      />
      <Header language={language} landingPage={landingPage} />
      <TranscriptionWorkspace
        isPremium={isPremium}
        language={language}
        mode={mode}
        onLanguageChange={changeLanguage}
        onModeChange={setMode}
        onRequirePremium={() => setShowPremiumPopup(true)}
        userData={userData}
      />
      {language === 'ca' && <TestimonialsSection />}
      {language === 'ca' && <SeoContentBlock landingPage={landingPage} />}
      <Credits />
      <CookieBanner />
    </div>
  );
}
